import { useEffect, useState } from "react";
import { CalendarDays, Clock, MessageCircleHeart, X } from "lucide-react";
import api from "@/lib/api";

/* Shown after a class video finishes. Hands over to the chat widget via a window event. */
export const ReviewInvite = ({ day, onClose }) => {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { api.get("/chat/config").then((r) => setCfg(r.data)).catch(() => setCfg({})); }, []);
  if (!cfg || cfg.rv_invite_enabled === false || !cfg.enabled) return null;
  const start = (pickDay) => { window.dispatchEvent(new CustomEvent("pl:review", { detail: { day: pickDay ? null : day } })); onClose(); };
  return (
    <div data-testid="review-invite" className="mt-4 relative rounded-2xl border border-[#2F6B4F]/30 bg-[#F3F8F4] p-4 sm:p-5 text-[#1A2E26]">
      <button type="button" data-testid="review-invite-close" aria-label="Dismiss" onClick={onClose} className="absolute right-3 top-3 text-[#1A2E26]/50 hover:text-[#1A2E26]"><X size={16} /></button>
      <div className="flex items-start gap-3">
        <span className="grid place-items-center w-10 h-10 rounded-full bg-[#2F6B4F] text-white shrink-0"><MessageCircleHeart size={20} /></span>
        <div>
          <p className="font-serif text-lg leading-tight" data-testid="review-invite-title">{cfg.rv_invite_title || "Well done — you finished today's class!"}</p>
          <p className="mt-1 text-sm text-[#1A2E26]/75">{cfg.rv_invite_text}</p>
        </div>
      </div>
      <div className="mt-4 flex flex-wrap gap-2">
        <button type="button" data-testid="review-invite-start" onClick={() => start(false)} className="inline-flex items-center gap-2 rounded-full bg-[#2F6B4F] text-white text-sm font-semibold px-4 py-2 hover:bg-[#245a41]"><MessageCircleHeart size={15} /> Start Review Talk{day ? ` · Day ${day}` : ""}</button>
        <button type="button" data-testid="review-invite-later" onClick={onClose} className="inline-flex items-center gap-2 rounded-full border border-[#1A2E26]/20 bg-white text-sm px-4 py-2"><Clock size={15} /> Do It Later</button>
        <button type="button" data-testid="review-invite-other" onClick={() => start(true)} className="inline-flex items-center gap-2 rounded-full border border-[#1A2E26]/20 bg-white text-sm px-4 py-2"><CalendarDays size={15} /> Choose Another Day</button>
      </div>
    </div>
  );
};
